import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

class FieldValidationMessage extends PureComponent {
  getMessage = (msg) => {
    const { t } = this.props;
    return (t(msg));
  }

  render() {
    const { message } = this.props;
    const renderedMessages = (Array.isArray(message) ? message : [message]);
    return (
      <span>
        {renderedMessages.map(msg => <span key={msg}>{this.getMessage(msg)}</span>)}
      </span>
    );
  }
}


FieldValidationMessage.propTypes = {
  t: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};

export default withScopedTranslations('input_validation_messages')(FieldValidationMessage);
